import React from 'react';
import { useRecoilState } from 'recoil';
import useReset from '../../hooks/common/useReset';
import { alertState } from '../../data/estimate/common/common';
import AlertModal from './modal/AlertModal';
import { Alert } from '../../types/common/modal/alert';

/**
 *  경고성 메세지를 컨트롤 하는 컴포넌트
 *  */
function AlertArea(): JSX.Element | null {
  // reset
  useReset(alertState);

  const [alert, setAlert] = useRecoilState<Alert>(alertState);
  const { active, title, contents } = alert;
  return (
    <>
      {active ? (
        <AlertModal
          active={active}
          title={title}
          contents={contents}
          closeEvent={() => setAlert({ title: '안내', contents: '', active: false })}
        />
      ) : null}
    </>
  );
}

export default AlertArea;
